import React from 'react';
import { Edit3 } from 'react-feather';
import {
  InlineShell,
  InlineEyebrow,
  CardButton,
  type F8CardData,
  type OnAction,
} from './cardHelpers';

interface Tip {
  title?: string;
  content?: string;
  text?: string;
}

export default function TipsCard({
  card,
  onAction,
}: {
  card: F8CardData;
  onAction?: OnAction;
}) {
  const data = card?.data || {};
  const contactName: string | null = data.contactName || null;
  const tips: Tip[] = Array.isArray(data.tips) ? data.tips : [];

  if (tips.length === 0) return null;

  const eyebrowLabel = `${tips.length} tips${contactName ? ` · ${contactName}` : ''}`;

  return (
    <InlineShell>
      <InlineEyebrow label={eyebrowLabel} />

      <ol className="f8c-tips-list">
        {tips.map((tip, i) => (
          <li key={i} className="f8c-tips-item">
            <span className="f8c-tips-num">{i + 1}</span>
            <div className="f8c-tips-body">
              {tip.title && <div className="f8c-tips-title">{tip.title}</div>}
              <div className="f8c-tips-text">{tip.content || tip.text || ''}</div>
            </div>
          </li>
        ))}
      </ol>

      {contactName && (
        <div className="f8c-tips-actions">
          <CardButton
            primary
            small
            onClick={() =>
              onAction?.({
                action: 'skill_invoke',
                params: { message: `draft a message to ${contactName}` },
              })
            }
          >
            <Edit3 size={12} />
            Draft a message
          </CardButton>
        </div>
      )}
    </InlineShell>
  );
}
